module.exports = __webpack_public_path__ + "static/media/moodswings.66fb8276.png";